module.exports = __webpack_public_path__ + "static/media/teza.c6e308cd.jpg";